import React from 'react';

import { Trans } from 'lingui-react';
import { Button, Modal, ModalBody } from 'reactstrap';


import imageGroup from '../../../../assets/images/iconModal.svg';
import closeIcon from '../../../../assets/images/closeIconGray.svg';
import './modal.css';

export const ModalDashboad = props => {
  return (
    <div className="modal-dashboard-container">
      <Modal isOpen={props.isOpen} toggle={props.toggle} className={'mx-auto modal-dialog-dashboard '+ props.className}>
        <a onClick={props.toggle} className="close-button">
          <img onClick={props.toggle} className="close-icon" alt="" src={closeIcon} />
        </a>
        <ModalBody>
          <div className="row">
            <div className="col-12 col-sm-5">
              <img alt="" src={imageGroup} />
            </div>
            <div className="col-12 col-sm-7">
              <p className="title-dashboard"><Trans id="Assessment for your security level not supported" /></p>
              <p>{props.message}</p>
              <Button className="contact-button command-button" color="primary" onClick={() => { window.location = 'mailto:contact@securityselfie.ch'; }}><Trans id="Make Contact" /></Button>{' '}
              <Button className="continue-button command-button" color="primary" onClick={props.accept}><Trans id="Continue" /></Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div >
  )
}


// WEBPACK FOOTER //
// ./src/screens/Dashboard/components/ModalDashboad/ModalDashboad.js